var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"has-footer":true,"footer-actions":_vm.modalActions},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Чеклар ")]},proxy:true}])},[_c('div',[_vm._v("Modal")])])}
var staticRenderFns = []

export { render, staticRenderFns }